import { render } from "./VediPreventivoPage.vue?vue&type=template&id=b9a80f26"
import script from "./VediPreventivoPage.vue?vue&type=script&lang=js"
export * from "./VediPreventivoPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__